import {Component, ChangeDetectionStrategy} from '@angular/core';
import {RouterLink, RouterLinkActive, RouterOutlet} from "@angular/router";

@Component({
  selector: 'app-scoreboard',
  standalone: true,
  imports: [
    RouterOutlet,
    RouterLink,
    RouterLinkActive
  ],
  templateUrl: './scoreboard.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './scoreboard.component.scss'
})
export class ScoreboardComponent {

}
